export class Dictionary {
  id: number;
  text: string;
  countries: any[];

  setFromApiModel(apiModel: any, country?): this {
    this.id = apiModel.id;
    this.text = apiModel.name;

    if (apiModel.countries) {
      this.countries = apiModel.countries.map(item => new Dictionary().setFromApiModel(item));
    }
    return this;
  }
}
